import { Form } from 'antd';
import { useField } from 'formik';
import { isEqual } from 'lodash/fp';
import { useEffect } from 'react';
import { type InputFieldProps } from '../../../components/fields/InputField';
import { StyledTextFieldWrapper } from './shared';
import useRenderTooltip from './useRenderTooltip';
import { getTextFieldState } from './utils';

const InputField = ({
    type = 'text',
    placeholder,
    status,
    label,
    required = false,
    name,
    itemProps,
    tooltip,
    disabled,
    maxLength,
    onKeyPress,
    removeWhiteSpace,
}: InputFieldProps) => {
    const [field, meta, helper] = useField({ name });

    const renderTooltip = useRenderTooltip(tooltip);

    useEffect(() => {
        if (removeWhiteSpace && typeof field.value === 'string') {
            helper.setValue(field.value.replace(/\s/g, ''));
        }
    }, [removeWhiteSpace, field.value, helper]);

    const hasError = !!meta?.error && (meta?.touched || !isEqual(meta?.initialValue, meta?.value));
    const errorMessage = Array.isArray(meta?.error) ? '' : meta?.error;

    return (
        <Form.Item {...itemProps} required={required}>
            <StyledTextFieldWrapper state={hasError ? 'error' : getTextFieldState(status)}>
                {label && (
                    <span slot="label">
                        {label}
                        {renderTooltip()}
                    </span>
                )}
                {itemProps?.help && <span slot="description">{itemProps?.help}</span>}
                <input
                    {...field}
                    disabled={disabled}
                    maxLength={maxLength}
                    onKeyPress={onKeyPress}
                    placeholder={placeholder}
                    required={required}
                    type={type}
                    value={field.value || ''}
                />
                {hasError && <span slot="message">{errorMessage}</span>}
            </StyledTextFieldWrapper>
        </Form.Item>
    );
};

export default InputField;
